import {Suspense, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import withErrorBoundary from 'commons/withErrorBoundary';
import {compose} from 'commons/utils';
import Logger from 'commons/logger';
import 'commons/i18n';
import {AuthProvider} from 'contextApi/context/auth';
import Loading from 'components/loader/Loader';
import Navigation from 'navigation';
import {ThemeProvider} from '@mui/material';
import {theme} from './theme/theme.provider';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import AlertProvider from './contextApi/context/error';
import {registerLocale as registerCountryLocale} from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import es from 'i18n-iso-countries/langs/es.json';
import fr from 'i18n-iso-countries/langs/fr.json';
import pt from 'i18n-iso-countries/langs/pt.json';
import {getMuiDateLocaleText} from 'commons/dateLocaleMapper';
import './App.css';

const App = () => {
  const {i18n} = useTranslation();

  useEffect(() => {
    // Register country locales for i18n-iso-countries
    registerCountryLocale(en);
    registerCountryLocale(es);
    registerCountryLocale(fr);
    registerCountryLocale(pt);

    Logger.init();
  }, []);

  // Sync document.lang whenever language changes
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <Suspense
      fallback={
        <>
          <Loading loaderStyles="" />
        </>
      }
    >
      <ThemeProvider theme={theme}>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          localeText={getMuiDateLocaleText(
            i18n.language as 'en' | 'es' | 'fr' | 'pt'
          )}
        >
          <AuthProvider>
            <AlertProvider>
              <div className="Navigation">
                <Navigation />
              </div>
            </AlertProvider>
          </AuthProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </Suspense>
  );
};

export default compose(withErrorBoundary)(App);
